export function formatNumberToHuman(n: number) {
  if (n == null) {
    return;
  }
  if (n < 1000) {
    return String(n);
  }
  if (n < 100000) {
    return Math.floor(n / 100) / 10 + "k";
  }
  if (n < 1000000) {
    return Math.floor(n / 1000) + "k";
  }
  if (n < 1000000000) {
    return Math.floor(n / 100000) / 10 + "M";
  }

  return Math.floor(n / 10 ** 8) / 10 + "B";
}
